var map = {
	"./activityAnalysis.svg": 66006,
	"./budgetReport.svg": 58866,
	"./conditionAnalysis.svg": 59960,
	"./creditorExpenses.svg": 17956,
	"./creditorOpenItems.svg": 67417,
	"./debtorOpenItems.svg": 75953,
	"./debtorRevenue.svg": 5769,
	"./defaultReport.svg": 46640,
	"./insuranceOverview.svg": 81196,
	"./investmentPlan.svg": 6481,
	"./landRegisterOverview.svg": 31378,
	"./maintenanceOverview.svg": 85189,
	"./marketingHistory.svg": 81735,
	"./mortgageAnalysis.svg": 45855,
	"./occupancyRegister.svg": 42641,
	"./revenueOverview.svg": 20960,
	"./vacancyReport.svg": 24216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31199;